export default __webpack_public_path__ + "static/media/factory__3.cf1434bb.jpg";